import { medialUrl } from "../../../EndPoints";
import { ApartmentIcon } from "../../Woven/components/WovenMedias";

// Sweater
import Sweater from "../../../assets/images/products/sweater/sweater.png";
import Pullover from "../../../assets/images/products/sweater/pullover.png";
import Cardigan from "../../../assets/images/products/sweater/cardigan.png";
import Scarf from "../../../assets/images/products/sweater/scarf.png";
import Caps from "../../../assets/images/products/sweater/caps.png";

import TypesOfYarnImg from "../../../assets/images/products/sweater/types-of-yarn.png";
import LocalYarnImg from "../../../assets/images/products/sweater/local-yarn.png";
import ForeignYarnImg from "../../../assets/images/products/sweater/foreign-yarn.png";

import ProductionQualityBg from "../../../assets/images/products/sweater/production-quality-bg.png";
import ProductionQualityIcon from "../../../assets/images/products/sweater/production_quality_icon.png";
import FireExtinguisherBg from "../../../assets/images/products/sweater/fire-extinguisher-bg.png";
import FireExtinguisherIcon from "../../../assets/images/products/sweater/fire_extinguisher_icon.png";
import KnittingAreaBg from "../../../assets/images/products/sweater/knitting-area-bg.png";
import KnittingAreaIcon from "../../../assets/images/products/sweater/knitting_area_icon.png";

import LinkingProductBg from "../../../assets/images/products/sweater/linking-production-bg.png";
import LinkingProductIcon from "../../../assets/images/products/sweater/production-area-icon.png";

export const sweaterStatCounter = [
  {
    sign: "ACCORD",
    text: "Approved",
    icon: ApartmentIcon,
  },
  {
    number: "0.0",
    sign: "%",
    text: "Re-work & Re-check",
    icon: ApartmentIcon,
  },
];

export const sweaterArray = [
  {
    img: Sweater,
    text: "Sweater",
  },
  {
    img: Pullover,
    text: "Pullover",
  },
  {
    img: Cardigan,
    text: "Cardigan",
  },
  {
    img: Scarf,
    text: "Scarf",
  },
  {
    img: Caps,
    text: "Caps",
  },
];

// SweaterFirstSection
const SweaterFirstSectionContent1 = [
  ProductionQualityBg,
  ProductionQualityIcon,
];
const SweaterFirstSectionContent2 = [FireExtinguisherBg, FireExtinguisherIcon];

const SweaterFirstSectionContent3 = [KnittingAreaBg, KnittingAreaIcon];

const SweaterFirstSectionContent4 = [LinkingProductBg, LinkingProductIcon];
export const SweaterFirstSectionContent = [
  {
    bgDecoratorSrc: SweaterFirstSectionContent1[0],
    icon: SweaterFirstSectionContent1[1],
    title: "70,000 sq. ft",
    text: "Production & Quality Space",
  },
  {
    bgDecoratorSrc: SweaterFirstSectionContent2[0],
    icon: SweaterFirstSectionContent2[1],
    title: "150 +",
    text: "Fire Extinguishers",
  },
  {
    bgDecoratorSrc: SweaterFirstSectionContent3[0],
    icon: SweaterFirstSectionContent3[1],
    title: "14,000 sq. ft",
    text: "Knitting Production Area",
  },
  {
    bgDecoratorSrc: SweaterFirstSectionContent4[0],
    icon: SweaterFirstSectionContent4[1],
    title: "10,000 sq. ft",
    text: "Linking Production Area",
  },
];

// SweaterThirdSection
const SweaterThirdSectionContent1 = [TypesOfYarnImg];
const SweaterThirdSectionContent2 = [LocalYarnImg];
const SweaterThirdSectionContent3 = [ForeignYarnImg];

export const SweaterThirdSectionContent = [
  {
    text: [
      {
        title: "Types of",
        title2: "Yarn",
        description:
          "100% Cotton, Acrylic, Cashmere-like, Rayon, Acrylic Cotton-like, Wool, Viscose, Chenille Acrylic Strings, Tube Yarn and Roving, 50% Acrylic, 50% Wool, Cotton Melange, 65% Cotton, 45% Wool, 70% Acrylic, 30% Wool & All kinds of fancy yarn",
      },
    ],
    src: SweaterThirdSectionContent1,
  },
  {
    text: [
      {
        title: "Local Yarn",
        title2: "Sourcing",
        description:
          "Dayue Bangladesh Ltd., Queen South, Kung King, Ring Shine, Laibie Dyeing, Cotton, Fare Trade, Color Master, Shepherd etc.",
      },
    ],
    src: SweaterThirdSectionContent2,
  },
  {
    text: [
      {
        title: "Foreign",
        title2: "Sourcing",
        description:
          "Bros, Huafu, UPWF, FillW, Jiangsu Gotal, Luggang, Ferney, Filcom etc.",
      },
    ],
    src: SweaterThirdSectionContent3,
  },
];
